// extracted by mini-css-extract-plugin
export default {"counter":"AmountOfCards_counter__VxFJ3"};